import { useState, useEffect } from 'react';
import { networkApi } from '../api/networkApi';

export const useNetworks = () => {
  const [networks, setNetworks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNetworks = async () => {
      try {
        setLoading(true);
        const data = await networkApi.searchOpenNetworks();
        setNetworks(data.result || []);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNetworks();
  }, []);

  return { networks, loading, error };
};

export const useNetwork = (networkId) => {
  const [network, setNetwork] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!networkId) {
      setLoading(false);
      return;
    }

    const fetchNetwork = async () => {
      try {
        setLoading(true);
        const data = await networkApi.getNetworkById(networkId);
        setNetwork(data);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNetwork();
  }, [networkId]);

  return { network, loading, error };
};

export const useNetworkByName = (networkName) => {
  const [network, setNetwork] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!networkName) {
      setLoading(false);
      return;
    }

    const fetchNetwork = async () => {
      try {
        console.log('useNetworkByName: Fetching network by name:', networkName);
        setLoading(true);
        const data = await networkApi.getNetworkByName(networkName);
        console.log('useNetworkByName: Found network:', data);
        setNetwork(data);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNetwork();
  }, [networkName]);

  return { network, loading, error };
};

export const useNetworkByCode = (networkCode) => {
  const [network, setNetwork] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!networkCode) {
      setLoading(false);
      return;
    }

    const fetchNetwork = async () => {
      try {
        console.log('useNetworkByCode: Fetching network by code:', networkCode);
        setLoading(true);
        const data = await networkApi.getNetworkByCode(networkCode);
        console.log('useNetworkByCode: Found network:', data);
        setNetwork(data);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNetwork();
  }, [networkCode]);

  return { network, loading, error };
};

export const useNetworkBySubdomain = (subdomain) => {
  const [network, setNetwork] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!subdomain) {
      setLoading(false);
      return;
    }

    const fetchNetwork = async () => {
      try {
        console.log('useNetworkBySubdomain: Fetching network by subdomain:', subdomain);
        setLoading(true);
        const data = await networkApi.getNetworkBySubdomain(subdomain);
        console.log('useNetworkBySubdomain: Found network:', data);
        setNetwork(data);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNetwork();
  }, [subdomain]);

  return { network, loading, error };
};
